import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const InitialLoadGate = ({ children }) => {
  const [phase, setPhase] = useState('done');
  const location = useLocation();

  useEffect(() => {
    const fromLogin = sessionStorage.getItem('showLoginAnimation') === 'true';
    const referrer = document.referrer || '';
    const fromMarketingSite = referrer && (
      referrer.includes('zenitailab.com') ||
      referrer.includes('localhost:3000')
    );
    const animationShownThisSession = sessionStorage.getItem('animationShownThisSession');
    
    let shouldShow = false;
    
    if (fromLogin) {
      shouldShow = true;
    } else if (!animationShownThisSession && fromMarketingSite) {
      shouldShow = true;
    }
    
    if (!shouldShow) return;

    sessionStorage.setItem('animationShownThisSession', 'true');
    setPhase('loading');

    const timer1 = setTimeout(() => {
      setPhase('exiting');

      const timer2 = setTimeout(() => {
        setPhase('done');
        sessionStorage.removeItem('showLoginAnimation');
      }, 800);

      return () => clearTimeout(timer2);
    }, 600);

    return () => clearTimeout(timer1);
  }, [location.pathname]);

  const isGateVisible = phase === 'loading' || phase === 'exiting';

  return (
    <>
      {/* App Content */}
      <div 
        style={{
          display: phase === 'done' ? 'block' : 'none'
        }}
      >
        {children}
      </div>

      {/* Loading Gate */}
      {isGateVisible && (
        <div 
          className={`
            fixed inset-0 z-[99999] 
            flex items-center justify-center
            bg-gradient-to-b from-[#0a0014] to-black
            ${phase === 'exiting' ? 'animate-fadeOut' : ''}
          `}
          style={{
            animation: phase === 'exiting' ? 'fadeOut 800ms ease-out forwards' : 'none'
          }}
        >
          {/* Ambient Glow */}
          <div 
            className="absolute inset-0 opacity-80"
            style={{
              background: 'radial-gradient(circle at 50% 50%, rgba(136, 68, 245, 0.08), transparent 60%)'
            }}
          />

          {/* Content */}
          <div className="relative z-10 flex flex-col items-center gap-3">
            {/* Title */}
            <h1 
              className={`
                text-sm md:text-base
                tracking-[0.24em] text-white
                ${phase === 'loading' ? 'animate-slideUp' : ''}
              `}
              style={{
                animation: phase === 'loading' ? 'slideUp 600ms ease-out forwards' : 'none',
                opacity: phase === 'loading' ? 0 : 1,
                transform: phase === 'loading' ? 'translateY(8px)' : 'translateY(0)'
              }}
            >
              ZENIT AI LAB
            </h1>

            {/* Progress Bar */}
            <div className="relative w-[150px] sm:w-[200px] md:w-[280px] h-[5px] rounded-full bg-white/10 border border-white/[0.08] overflow-hidden">
              {/* Animated Fill */}
              <div 
                className="absolute top-0 left-0 h-full rounded-full bg-gradient-to-r from-[#6b3fc1] via-[#8844f5] to-[#b366ff] shadow-[0_0_12px_rgba(136,68,245,0.65)]"
                style={{
                  width: '100%',
                  animation: 'barSweep 1.8s cubic-bezier(0.22, 0.78, 0.25, 1) infinite',
                  transform: 'translateX(-118%)'
                }}
              />
              
              {/* Head Dot */}
              <div 
                className="absolute top-1/2 w-[18px] h-[18px] rounded-full -translate-y-1/2 shadow-[0_0_24px_rgba(179,102,255,0.72)]"
                style={{
                  left: '0%',
                  background: 'radial-gradient(circle at 35% 35%, rgba(255, 255, 255, 0.95), rgba(179, 102, 255, 0.95) 48%, rgba(107, 63, 193, 0.25))',
                  animation: 'headSweep 1.8s cubic-bezier(0.22, 0.78, 0.25, 1) infinite',
                  transform: 'translate(-50%, -50%)'
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Keyframes */}
      <style>{`
        @keyframes fadeOut {
          to {
            opacity: 0;
            visibility: hidden;
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 0.92;
            transform: translateY(0);
          }
        }

        @keyframes barSweep {
          0% {
            transform: translateX(-118%);
          }
          54% {
            transform: translateX(108%);
          }
          100% {
            transform: translateX(108%);
          }
        }

        @keyframes headSweep {
          0% {
            left: 0%;
          }
          54% {
            left: 100%;
          }
          100% {
            left: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default InitialLoadGate;
